import React from 'react'

export const EditIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.05 3.00002L4.20829 10.2417C3.94996 10.5167 3.69996 11.0584 3.64996 11.4334L3.34162 14.1334C3.23329 15.1084 3.93329 15.775 4.89996 15.6084L7.58329 15.15C7.95829 15.0834 8.48329 14.8084 8.74162 14.525L15.5833 7.28335C16.7666 6.03335 17.3 4.60835 15.4583 2.86668C13.625 1.14168 12.2333 1.75002 11.05 3.00002Z"
        stroke="#011533"
        stroke-width="1.5"
        stroke-miterlimit="10"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.9082 4.20801C10.2665 6.50801 12.1332 8.26634 14.4499 8.49967"
        stroke="#011533"
        stroke-width="1.5"
        stroke-miterlimit="10"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.5 18.333H17.5"
        stroke="#011533"
        stroke-width="1.5"
        stroke-miterlimit="10"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
